import { ThemeOptions } from '@mui/material';
import { primary } from './colors.tsx';

export const themeTableOptions: ThemeOptions['components'] = {
  MuiTableRow: {
    styleOverrides: {
      root: {
        border: 'unset',
        '&:nth-of-type(even)': {
          backgroundColor: '#F8F8F8',
        },
      },
    },
  },
  MuiTable: {
    styleOverrides: {
      root: {
        '& td': { border: 0 },
        '& .MuiTableHead-root': {
          background: `${primary.main}!important`,
          borderRadius: 0,
          color: 'white',
          fontFamily: 'sans-serif',
          fontSize: '14px',
          '& .MuiTableSortLabel-root': {
            color: 'white',
            svg: {
              color: 'white',
            },
          },
        },
      },
    },
  },
};
